import service from "@/store/services/suppliers-service";

export const state = () => ({
  list: {},
  supplier: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, supplier) => {
    state.supplier = supplier;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((supplier) => {
      commit("SET_RESOURCE", supplier);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((supplier) => {
      commit("SET_RESOURCE", supplier);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((supplier) => {
      commit("SET_RESOURCE", supplier);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  supplier: (state) => state.supplier,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((supplier) => ({
      id: supplier.id,
      name: supplier.company_name,
    }));
  },
};

const suppliers = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default suppliers;
